import React from 'react';
import { LogInLink } from '../styles';
import { Body1, Body1PointerLink } from '../../../../../components/Font';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const FooterLink = () => {
	const navigate = useNavigate();
	const { search } = useLocation();
	const { t } = useTranslation();

	return (
		<LogInLink className='login-link' style={{ position: 'relative', bottom: '0' }}>
			<Body1>{t('passport.registrationForm.haveAccount.name')}</Body1>
			<Body1PointerLink
				onClick={() => {
					navigate(`/sign-in${search}`);
				}}
			>
				{t('passport.registrationForm.loginButton.name')}
			</Body1PointerLink>
		</LogInLink>
	);
};
